import {
    PCOR_DATA_FAILURE,
    PCOR_DATA_LOADING,
    PCOR_DATA_REQUEST,
    PCOR_DATA_SUCCESS,
    PCOR_FILTER_REQUEST,
    PCOR_FILTER_SUCCESS,
    PCOR_FILTER_FAILURE,
    PCOR_FILTER_LOADING,
} from '../actionTypes';

export const getPCORMeasureDataRequest = (payload: any) => ({
    type: PCOR_DATA_REQUEST,
    payload
});

export const getPCORMeasureDataSuccess = (data: any) => ({
    type: PCOR_DATA_SUCCESS,
    payload: data
});

export const getPCORMeasureDataError = (error: any) => ({
    type: PCOR_DATA_FAILURE,
    payload: { error }
});

export const setPCORMeasureLoading = (payload: any) => ({
    type: PCOR_DATA_LOADING,
    payload
});

// PCOR Filter Actions
export const getPCORFilterRequest = (payload: any) => ({
    type: PCOR_FILTER_REQUEST,
    payload
});

export const getPCORFilterSuccess = (data: any) => ({
    type: PCOR_FILTER_SUCCESS,
    payload: data
});

export const getPCORFilterError = (error: any) => ({
    type: PCOR_FILTER_FAILURE,
    payload: { error }
});

export const setPCORFilterLoading = (payload: any) => ({
    type: PCOR_FILTER_LOADING,
    payload
});